
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/health",
      function () {
        return require("private-next-pages/health.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/health"])
      });
    }
  